import PageControl from './pageControl'
import UpdateTools from './updateTools'

export default {
  ...PageControl,
  ...UpdateTools,
}
